// SEO Configuration for Homely Solutions
// Villes par canton pour pages SEO locales

export const seoCities = {
  vaud: [
    'Lausanne', 'Montreux', 'Vevey', 'Nyon', 'Morges', 'Renens', 'Yverdon-les-Bains',
    'Pully', 'Prilly', 'La Tour-de-Peilz', 'Gland', 'Aigle', 'Bex', 'Villeneuve',
    'Rolle', 'Aubonne', 'Cossonay', 'Echallens', 'Moudon', 'Payerne', 'Orbe',
    'Chavornay', 'Grandson', 'Sainte-Croix', 'Le Sentier', 'Vallée de Joux',
    'Lutry', 'Cully', 'Bussigny', 'Crissier'
  ],
  geneve: [
    'Genève', 'Carouge', 'Vernier', 'Lancy', 'Meyrin', 'Onex', 'Thônex',
    'Versoix', 'Grand-Saconnex', 'Plan-les-Ouates', 'Chêne-Bougeries', 'Bernex',
    'Chêne-Bourg', 'Cologny', 'Collonge-Bellerive', 'Vandoeuvres', 'Pregny-Chambésy',
    'Bellevue', 'Genthod', 'Hermance', 'Anières', 'Corsier', 'Jussy', 'Puplinge',
    'Presinge', 'Choulex', 'Meinier', 'Gy', 'Avusy', 'Laconnex'
  ],
  valais: [
    'Sion', 'Sierre', 'Martigny', 'Monthey', 'Brig-Glis', 'Naters', 'Visp',
    'Crans-Montana', 'Verbier', 'Zermatt', 'Saas-Fee', 'Leukerbad', 'Champéry',
    'Val-d\'Illiez', 'Troistorrents', 'Saint-Maurice', 'Fully', 'Saxon', 'Conthey',
    'Savièse', 'Ayent', 'Lens', 'Bagnes', 'Orsières', 'Liddes', 'Evolène',
    'Hérémence', 'Nendaz', 'Veysonnaz', 'Anzère'
  ],
  fribourg: [
    'Fribourg', 'Bulle', 'Villars-sur-Glâne', 'Marly', 'Granges-Paccot', 'Givisiez',
    'Düdingen', 'Murten', 'Estavayer-le-Lac', 'Romont', 'Châtel-Saint-Denis',
    'Attalens', 'Vaulruz', 'Broc', 'Gruyères', 'Moléson', 'Charmey', 'Jaun',
    'Schwarzsee', 'La Roche', 'Treyvaux', 'Hauterive', 'Matran', 'Avry',
    'Corminboeuf', 'Belfaux', 'Courtepin', 'Flamatt', 'Wünnewil', 'Tafers'
  ],
  neuchatel: [
    'Neuchâtel', 'La Chaux-de-Fonds', 'Le Locle', 'Peseux', 'Boudry', 'Cortaillod',
    'Saint-Blaise', 'Marin-Epagnier', 'Colombier', 'Bevaix', 'Gorgier', 'Saint-Aubin',
    'Môtiers', 'Fleurier', 'Couvet', 'Travers', 'Les Verrières', 'La Brévine',
    'Le Cerneux-Péquignot', 'Les Ponts-de-Martel', 'La Sagne', 'Les Brenets',
    'Le Landeron', 'Cressier', 'Cornaux', 'Hauterive', 'Fontainemelon', 'Cernier',
    'Dombresson', 'Villiers'
  ]
};

// Services pour pages SEO
export const seoServices = [
  {
    slug: 'nettoyage',
    name: 'Nettoyage professionnel',
    title: 'Nettoyage professionnel à {city}',
    description: 'Service de nettoyage professionnel à {city}. Nettoyage de canapé, terrasse, vitres, fin de chantier et après bail. Intervention rapide par Homely Solutions.',
    h1: 'Expert en nettoyage à {city}',
    intro: 'Vous recherchez un service de nettoyage fiable et professionnel à {city} ? Homely Solutions intervient rapidement pour redonner éclat à votre intérieur.'
  },
  {
    slug: 'renovation',
    name: 'Rénovation intérieure',
    title: 'Rénovation intérieure à {city}',
    description: 'Rénovation complète et partielle à {city}. Cuisine, salle de bain, peinture, parquet. Coordination de chantier par Homely Solutions.',
    h1: 'Rénovation intérieure à {city}',
    intro: 'Envie de transformer votre intérieur à {city} ? Nos équipes coordonnent votre rénovation de A à Z, avec un suivi rigoureux et des finitions impeccables.'
  },
  {
    slug: 'montage',
    name: 'Montage de meubles',
    title: 'Montage de meubles à {city}',
    description: 'Montage de meubles IKEA, Conforama, Lipo à {city}. Livraison et installation professionnelle. Service Handy Man par Homely Solutions.',
    h1: 'Montage et installation à {city}',
    intro: 'Besoin de faire monter vos meubles à {city} ? Nos techniciens interviennent rapidement pour assembler tous types de meubles avec précision.'
  },
  {
    slug: 'conciergerie',
    name: 'Conciergerie Airbnb',
    title: 'Conciergerie Airbnb à {city}',
    description: 'Service de conciergerie Airbnb et location saisonnière à {city}. Gestion complète : annonces, pricing dynamique, accueil voyageurs, ménage. Homely Conciergerie, votre partenaire en Suisse romande.',
    h1: 'Conciergerie Airbnb à {city}',
    intro: 'Propriétaire d\'un bien à {city} ? Notre service de conciergerie gère votre location saisonnière de A à Z : création d\'annonce, pricing, accueil voyageurs et ménage. Maximisez vos revenus sans stress.'
  },
  {
    slug: 'immo',
    name: 'Vente immobilière',
    title: 'Vente immobilière à {city}',
    description: 'Accompagnement pour vendre votre bien à {city}. Estimation, valorisation, annonces, visites et négociation. Homely Immo vous guide jusqu\'à la vente.',
    h1: 'Vendre votre bien à {city}',
    intro: 'Vous souhaitez vendre votre appartement ou maison à {city} ? Homely Immo vous accompagne de l\'estimation à la signature chez le notaire.'
  },
  {
    slug: 'marketing',
    name: 'Marketing digital',
    title: 'Marketing digital à {city}',
    description: 'Agence marketing digital à {city}. Création de site web, SEO, publicité Google, réseaux sociaux. Boostez votre visibilité avec Homely Marketing.',
    h1: 'Marketing digital à {city}',
    intro: 'Vous êtes une entreprise à {city} et vous voulez développer votre visibilité en ligne ? Homely Marketing vous accompagne avec des solutions sur mesure.'
  }
];

// Structured Data templates
export const structuredData = {
  organization: {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Homely Solutions",
    "alternateName": ["Homely Nettoyage", "Homely Conciergerie", "Homely Rénovation", "Homely Montage", "Homely Marketing", "Homely Immo"],
    "url": "https://www.homely-solutions.ch",
    "logo": "https://www.homely-solutions.ch/logo.png",
    "description": "Homely Solutions est la référence en Suisse romande pour les services immobiliers : nettoyage, conciergerie Airbnb, rénovation, montage de meubles et vente immobilière.",
    "foundingDate": "2014",
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": 46.5197,
        "longitude": 6.6323
      },
      "geoRadius": "150000"
    },
    "address": {
      "@type": "PostalAddress",
      "addressRegion": "Suisse romande",
      "addressCountry": "CH"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+41-79-123-45-67",
      "contactType": "customer service",
      "availableLanguage": ["French", "German", "English"]
    },
    "sameAs": [
      "https://www.homely-nettoyage.ch",
      "https://www.homely-conciergerie.ch",
      "https://www.homely-renovation.ch",
      "https://www.homely-montage.ch"
    ]
  },
  localBusiness: {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Homely Solutions",
    "image": "https://www.homely-solutions.ch/og-image.jpg",
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "addressRegion": "Vaud",
      "addressCountry": "CH"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 46.5197,
      "longitude": 6.6323
    },
    "telephone": "+41-79-123-45-67",
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "08:00",
      "closes": "18:00"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "127"
    }
  }
};

// Meta tags for pages
export const defaultMeta = {
  title: "Homely Solutions | Services immobiliers haut de gamme en Suisse romande",
  description: "Nettoyage, conciergerie Airbnb, rénovation, montage de meubles et vente immobilière. Homely Solutions, votre partenaire de confiance en Suisse romande.",
  keywords: "nettoyage suisse romande, conciergerie airbnb genève, rénovation lausanne, montage meubles ikea suisse, vente immobilière vaud",
  author: "Homely Solutions",
  robots: "index, follow",
  ogType: "website",
  ogImage: "https://www.homely-solutions.ch/og-image.jpg"
};
